import React from 'react';
import { Button } from '@nooz-optics/nooz-components-lib';
import { withPrefix } from 'gatsby';
import { returnLocalisedPath } from '../../../../utils/globals';
import { withLocale } from '../../../../utils/hocs';

export const ButtonWrapper = withLocale((props) => {
  if (props.slug && props.obfuscate) {
    // If button is obfuscated, return a button instead of a link with a onclick navigate function
    return <Button {...props} />;
  } else if (props.slug) {
    // Link button
    return (
      <a
        href={withPrefix(
          returnLocalisedPath(props.locale[0], props.slug?.url)
        )}>
        <Button {...props} />
      </a>
    );
  } else {
    // Functional button
    return <Button {...props} />;
  }
});
